var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPlayListLine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H12V20H2V18ZM2 11H16V13H2V11ZM2 4H22V6H2V4ZM19 15.17V9H24V11H21V18C20.9997 18.6368 20.7967 19.2569 20.4206 19.7707C20.0444 20.2844 19.5145 20.6652 18.9076 20.8578C18.3007 21.0505 17.6482 21.045 17.0446 20.8422C16.441 20.6394 15.9176 20.2498 15.5501 19.7298C15.1826 19.2098 14.9901 18.5864 15.0004 17.9497C15.0107 17.313 15.2234 16.6961 15.6076 16.1883C15.9918 15.6805 16.5276 15.3082 17.1375 15.1251C17.7473 14.942 18.3997 14.9577 19 15.17ZM18 19C18.2652 19 18.5196 18.8946 18.7071 18.7071C18.8946 18.5196 19 18.2652 19 18C19 17.7348 18.8946 17.4804 18.7071 17.2929C18.5196 17.1054 18.2652 17 18 17C17.7348 17 17.4804 17.1054 17.2929 17.2929C17.1054 17.4804 17 17.7348 17 18C17 18.2652 17.1054 18.5196 17.2929 18.7071C17.4804 18.8946 17.7348 19 18 19Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayListLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play-list-line.dd758442e7e0a7fd420797af2af2305e.svg";